import { render, staticRenderFns } from "./ScienceModule.vue?vue&type=template&id=59535784"
import script from "./ScienceModule.vue?vue&type=script&lang=ts"
export * from "./ScienceModule.vue?vue&type=script&lang=ts"
import style0 from "./ScienceModule.vue?vue&type=style&index=0&id=59535784&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports